import React from 'react';
import PropTypes from 'prop-types';

import PopupFilter from './popupFilter';
import { Button, Select } from 'semantic-ui-react';

/**
 * Zone filter
 */
export default class MultiSelectFilter extends React.Component {
    constructor() {
        super(...arguments);

        let query = this.props.query();
        let value = null;

        if (query[this.props.name]) {
            value = query[this.props.name];
            if (!(value instanceof Array)) {
                value = [value];
            }
            value = value.map(value => (isNaN(+value) ? value : +value));
        }

        this.state = {
            value,
            open: true
        };

        if (this.props.setClearer) {
            this.props.setClearer(() => this.clear(false));
        }
    }

    clear(triggerEvents = true) {
        this.setState(
            {
                value: null,
                open: true
            },
            () => {
                this.props.removeFromQuery(this.props.name);
                if (triggerEvents) {
                    this.props.onChange(this.props.name);
                    this.props.onClear(this.props.name);
                }
            }
        );
    }

    onChange(selected) {
        if (!selected || !selected.length) {
            this.clear();
        }

        this.setState({
            value: selected
        });
    }

    toggle() {
        this.setState({
            open: false
        });
    }

    onClose() {
        // make sure we change the filters
        // if there is a value and user clicks away
        if (this.state.value) {
            this.triggerChange(this.state.value);
        }
        return false;
    }

    triggerChange() {
        this.props.addToQuery(this.props.name, this.state.value);
        this.props.onChange(this.props.name, this.state.value);
    }

    render() {
        let buttonProps = {};

        if (this.state.value) {
            let label = this.props.getLabel(this.state.value);
            buttonProps.basic = false;
            buttonProps.label = label;
        }

        return (
            <PopupFilter
                clear={this.clear.bind(this)}
                label={this.props.filterLabel}
                buttonProps={buttonProps}
                value={this.state.value}
                controlled={true}
                open={this.state.open}
                onClose={this.onClose.bind(this)}
            >
                <div style={{ minWidth: '250px', width: 'max-content' }}>
                    <Select
                        search
                        fluid
                        multiple={true}
                        closeOnChange={false}
                        options={this.props.options.map(opt => ({ ...opt, key: opt }))}
                        value={this.state.value}
                        onChange={(synth, { value }) => this.onChange(value)}
                        style={{
                            display: 'inline-block',
                            minWidth: '150px',
                            width: this.props.width || 'calc(100% - 100px)',
                            marginRight: '5px'
                        }}
                    />
                    <Button
                        primary
                        icon="checkmark"
                        content="Ok"
                        disabled={!this.state.value}
                        onClick={() => {
                            this.toggle();
                            this.triggerChange();
                        }}
                    />
                </div>
            </PopupFilter>
        );
    }
}

MultiSelectFilter.defaultProps = {
    onClear: () => {},
    onChange: () => {},
    width: '',
    query: () => ({}),
    removeFromQuery: () => {},
    addToQuery: () => {}
};

MultiSelectFilter.propTypes = {
    getLabel: PropTypes.func,
    name: PropTypes.string.isRequired,
    onClear: PropTypes.func,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    setClearer: PropTypes.func,
    width: PropTypes.string,
    filterLabel: PropTypes.string.isRequired,
    query: PropTypes.func,
    removeFromQuery: PropTypes.func,
    addToQuery: PropTypes.func
};
